/** Vietnamese for the game owner's pages (Owner tabs, brand report), keyed by the English text. */
export const viAdmin: Record<string, string> = {
  "Game owner": "Chủ game",
  "Stats, accounts and moderation · every action is logged.": "Thống kê, tài khoản và kiểm duyệt · mọi thao tác đều được ghi lại.",
  "No events yet.": "Chưa có giải nào.",
  "Waiting for approval · {n}": "Chờ duyệt · {n}",
  "private": "riêng tư",
  "Decline": "Từ chối",
  "withdrawn request": "đã rút yêu cầu",
  "declined": "đã từ chối",
  "Hide": "Ẩn",
  "Unhide": "Bỏ ẩn",
  "Runners can create events": "Runner được tạo giải",
  "On: each runner creates a few events freely (below); more wait for your approval. Off: only you can create events. Existing events are not affected.": "Bật: mỗi runner được tạo miễn phí vài giải (bên dưới), các giải sau phải chờ anh duyệt. Tắt: chỉ anh được tạo giải. Các giải đã có không bị ảnh hưởng.",
  "Runners now get {n} free events": "Mỗi runner giờ được tạo {n} giải miễn phí",
  "Free events per runner": "Số giải miễn phí mỗi runner",
  "Over the life of the account (cancelled ones don’t count). Past this, each new event waits for your approval.": "Tính trên cả đời tài khoản (giải đã huỷ không tính). Vượt quá số này, mỗi giải mới phải chờ anh duyệt.",
  "No moderation actions yet.": "Chưa có thao tác quản trị nào.",
  "Unmark official": "Bỏ chính thức",
  "Mark official": "Đánh dấu chính thức",
  "Stats are not available.": "Chưa có số liệu.",
  "{pct} of accounts": "{pct} số tài khoản",
  "{n} in 30 days": "{n} trong 30 ngày",
  "Signed up with": "Đăng ký bằng",
  "Accounts": "Tài khoản",
  "Total": "Tổng",
  "last 24 h": "24 giờ qua",
  "{n} accounts have not opened the app in 30 days (tracked since 7 Oct 2026, so early numbers run high).": "{n} tài khoản chưa mở app trong 30 ngày (bắt đầu ghi từ 7/10/2026 nên số liệu ban đầu cao hơn thực tế).",
  "All accounts; those younger than a week may still get their second run.": "Tính mọi tài khoản; tài khoản chưa đủ một tuần vẫn có thể chạy buổi thứ hai.",
  "{a}/{b} joined 7–30 d ago, ran this week": "{a}/{b} người tham gia 7–30 ngày trước đã chạy trong tuần này",
  "{pct} of runs": "{pct} số buổi chạy",
  "{runs} runs and {km} km in the last 7 days": "{runs} buổi chạy và {km} km trong 7 ngày qua",
  "in app": "trong app",
  "of {n} allowed": "trên {n} được phép",
  "capacity not set": "chưa đặt giới hạn",
  "{skipped} skipped · {failed} failed": "{skipped} bỏ qua · {failed} lỗi",
  "API calls": "Lượt gọi API",
  "As counted by Strava, {time}.": "Theo số đếm của Strava, {time}.",
  "No Strava call since the last deploy, so Strava's own count is not known yet.": "Chưa có lượt gọi Strava nào từ lần deploy gần nhất, nên chưa biết số đếm của Strava.",
  "Our count: {today} today · {week} in 7 days": "Mình đếm: {today} hôm nay · {week} trong 7 ngày",
  "{n} hit the limit": "{n} lần chạm giới hạn",
  "Last Strava webhook: {time}": "Webhook Strava gần nhất: {time}",
  "none yet": "chưa có",
  "No clubs yet.": "Chưa có club nào.",
  "Ran 7d": "Chạy 7 ngày",
  "km 7d": "km 7 ngày",
  "{n} skipped, app was open": "{n} bỏ qua vì app đang mở",
  "{failed} failed · {expired} unsubscribed": "{failed} lỗi · {expired} đã huỷ đăng ký",
  "Switched off:": "Đã tắt:",
  "nobody": "không ai",
  "live + upcoming": "đang diễn ra + sắp tới",
  "{n} sectors held": "{n} ô có chủ",
  "Updated {time} · days in {tz}": "Cập nhật {time} · ngày tính theo {tz}",
  "runners per day": "runner mỗi ngày",
  "new accounts": "tài khoản mới",
  "max {n}": "tối đa {n}",
  "{day}: {runners} runners, {runs} runs, {signups} new": "{day}: {runners} runner, {runs} buổi chạy, {signups} tài khoản mới",
  "today": "hôm nay",
  "Players": "Người chơi",
  "New · 7 days": "Mới · 7 ngày",
  "Online now": "Đang online",
  "Opening the app": "Mở app",
  "Today": "Hôm nay",
  "7 days": "7 ngày",
  "30 days": "30 ngày",
  "New player funnel": "Phễu người chơi mới",
  "Signed up": "Đăng ký",
  "First run": "Buổi chạy đầu",
  "2 runs in the first week": "2 buổi chạy trong tuần đầu",
  "Joined a club": "Vào club",
  "Activity": "Hoạt động",
  "Ran today": "Chạy hôm nay",
  "Ran · 7 days": "Chạy · 7 ngày",
  "Ran · 30 days": "Chạy · 30 ngày",
  "Ever ran": "Đã từng chạy",
  "Came back": "Quay lại",
  "Flagged · 7 days": "Bị gắn cờ · 7 ngày",
  "Strava": "Strava",
  "Connected athletes": "VĐV đã kết nối",
  "Auto-import on": "Bật tự nhập",
  "Imports · 7 days": "Đã nhập · 7 ngày",
  "15 min": "15 phút",
  "Read · 15 min": "Đọc · 15 phút",
  "Read · today": "Đọc · hôm nay",
  "Push on": "Bật thông báo đẩy",
  "Sent · 7 days": "Đã gửi · 7 ngày",
  "Not delivered": "Không gửi được",
  "Community": "Cộng đồng",
  "Live events": "Giải đang diễn ra",
  "Upcoming events": "Giải sắp tới",
  "Event entries": "Lượt tham gia giải",
  "Clubs avg size": "Cỡ club trung bình",
  "Search by name or email": "Tìm theo tên hoặc email",
  "Search accounts": "Tìm tài khoản",
  "{n} accounts": "{n} tài khoản",
  "No accounts match.": "Không có tài khoản nào khớp.",
  "owner": "chủ game",
  "Lv {n}": "Cấp {n}",
  "no email (Strava sign-in)": "không có email (đăng nhập bằng Strava)",
  "Joined {date} · seen {seen} · last run {run}": "Tham gia {date} · mở app {seen} · chạy gần nhất {run}",
  "never": "chưa bao giờ",
  "{n} club handed over": "{n} club đã chuyển chủ",
  "{n} club deleted": "{n} club đã xoá",
  "{name} deleted": "Đã xoá {name}",
  "{runs} runs removed · {sectors} sectors back to neutral": "Đã xoá {runs} buổi chạy · {sectors} ô trở về trống",
  "Could not delete the account": "Không xoá được tài khoản",
  "Type {name} to confirm": "Gõ {name} để xác nhận",
  "Delete {name}?": "Xoá {name}?",
  "This permanently deletes the account ({email}) with all its runs, XP, comments, kudos and notifications. Its {n} sectors go back to neutral, a club it owns passes to its longest member (or is deleted if empty), and Strava access is revoked. This can’t be undone.": "Thao tác này xoá vĩnh viễn tài khoản ({email}) cùng mọi buổi chạy, XP, bình luận, kudos và thông báo. {n} ô của tài khoản trở về trống, club do tài khoản làm chủ được chuyển cho thành viên lâu nhất (hoặc bị xoá nếu không còn ai), và quyền truy cập Strava bị thu hồi. Không thể hoàn tác.",
  "Strava sign-in": "đăng nhập bằng Strava",
  "{n} run": "{n} buổi chạy",
  "{n} sector": "{n} ô",
  "City closed: only you see it now": "Đã đóng thành phố: giờ chỉ anh thấy",
  "A new city is seen and played by you only until you open it to every runner.": "Thành phố mới chỉ anh thấy và chơi được cho đến khi anh mở cho mọi runner.",
  "{sectors} sectors · {runs} valid runs": "{sectors} ô · {runs} buổi chạy hợp lệ",
  "Open": "Mở",
  "{city} is open to everyone": "Đã mở {city} cho mọi người",
  "{n} earlier runs now count there": "{n} buổi chạy trước đây giờ được tính ở đó",
  "Could not open the city": "Không mở được thành phố",
  "Open city": "Mở thành phố",
  "Open {city} to everyone?": "Mở {city} cho mọi người?",
  "Every runner can then see its map, run there, and pick it for events. Runs there count for XP, distance, sectors and rankings.": "Khi đó mọi runner đều thấy bản đồ, chạy ở đó và chọn thành phố này cho giải. Buổi chạy ở đó được tính XP, quãng đường, ô và xếp hạng.",
  "{n} earlier runs there were rejected as outside the game area. They will be judged again and count:": "{n} buổi chạy trước đây ở đó bị loại vì nằm ngoài vùng chơi. Các buổi này sẽ được chấm lại và tính điểm:",
  "No earlier runs to judge again.": "Không có buổi chạy cũ nào cần chấm lại.",
  "Open to everyone": "Mở cho mọi người",
  "Deleted an account": "Xoá một tài khoản",
  "Deleted their own account": "Tự xoá tài khoản",
  "Approved an event": "Duyệt một giải",
  "Declined an event": "Từ chối một giải",
  "Moderated an event": "Kiểm duyệt một giải",
  "Set an event’s sponsors": "Đặt nhà tài trợ cho giải",
  "Changed the game settings": "Đổi cài đặt game",
  "Opened a city": "Mở một thành phố",
  "Closed a city": "Đóng một thành phố",
  "Judged runs again in a city": "Chấm lại buổi chạy ở một thành phố",
  "Added a brand": "Thêm nhãn hàng",
  "Edited a brand": "Sửa nhãn hàng",
  "Deleted a brand": "Xoá nhãn hàng",
  "Restored a brand": "Khôi phục nhãn hàng",
  "Created a campaign": "Tạo chiến dịch",
  "Edited a campaign": "Sửa chiến dịch",
  "Set the campaign’s map cells": "Chọn ô bản đồ cho chiến dịch",
  "Created an offer": "Tạo ưu đãi",
  "Edited an offer": "Sửa ưu đãi",
  "Added offer codes": "Thêm mã ưu đãi",
  "Removed unused offer codes": "Xoá mã ưu đãi chưa phát",
  "Added a ledger entry": "Thêm khoản vào sổ tài trợ",
  "Edited a ledger entry": "Sửa khoản trong sổ tài trợ",
  "Deleted a ledger entry": "Xoá khoản trong sổ tài trợ",
  "Stats": "Thống kê",
  "Users": "Tài khoản",
  "Brands": "Nhãn hàng",
  "Ads": "Quảng cáo",
  "Offers": "Ưu đãi",
  "Ledger": "Sổ tài trợ",
  "Audit": "Nhật ký",
  "Newest": "Mới nhất",
  "Last seen": "Mở app gần nhất",
  "Top XP": "XP cao nhất",
  "Event approved": "Đã duyệt giải",
  "Event declined": "Đã từ chối giải",
  "Every runner can create events": "Mọi runner đều được tạo giải",
  "Only you can create events now": "Giờ chỉ anh được tạo giải",
  "{name} archived": "Đã lưu trữ {name}",
  "{name} restored": "Đã khôi phục {name}",
  "Sponsors and advertisers. Archived brands stay on events they sponsored.": "Nhà tài trợ và nhãn hàng quảng cáo. Nhãn hàng đã lưu trữ vẫn hiện trên các giải họ từng tài trợ.",
  "+ Brand": "+ Nhãn hàng",
  "No brands yet.": "Chưa có nhãn hàng nào.",
  "{n} event": "{n} giải",
  "{n} events": "{n} giải",
  "archived": "đã lưu trữ",
  "Report": "Báo cáo",
  "Restore": "Khôi phục",
  "{name} saved": "Đã lưu {name}",
  "Could not save the brand": "Không lưu được nhãn hàng",
  "Brand": "Nhãn hàng",
  "Edit {name}": "Sửa {name}",
  "New brand": "Nhãn hàng mới",
  "Upload logo (PNG, transparent background)": "Tải logo lên (PNG nền trong suốt)",
  "Website (https://…)": "Website (https://…)",
  "Notes (only you see them)": "Ghi chú (chỉ bạn thấy)",
  "Brand colour": "Màu nhãn hàng",
  "Sponsored map cells and Home banners. Runners get bonus XP the first time they capture a sponsored cell.": "Ô tài trợ trên bản đồ và banner Trang chủ. Runner được thưởng XP lần đầu chiếm một ô tài trợ.",
  "+ New": "+ Thêm",
  "No campaigns yet.": "Chưa có chiến dịch nào.",
  "cells": "ô",
  "cell views / taps": "xem / bấm ô",
  "banner views / taps": "xem / bấm banner",
  "runners bonused": "runner nhận thưởng",
  "Map cells": "Ô bản đồ",
  "Could not save the campaign": "Không lưu được chiến dịch",
  "Campaign": "Chiến dịch",
  "New campaign": "Chiến dịch mới",
  "Choose a brand…": "Chọn nhãn hàng…",
  "Add brands in the Brands tab first.": "Hãy thêm nhãn hàng ở tab Nhãn hàng trước.",
  "City": "Thành phố",
  "Link (blank = brand website)": "Link (để trống = website nhãn hàng)",
  "Home banner (3:1, e.g. 1200×400)": "Banner Trang chủ (tỉ lệ 3:1, vd. 1200×400)",
  "Change banner": "Đổi banner",
  "Upload banner": "Tải banner lên",
  "Paused (hidden, no bonus XP)": "Tạm dừng (ẩn, không thưởng XP)",
  "Save, then pick map cells": "Lưu rồi chọn ô trên bản đồ",
  "{n} cells saved for {name}": "Đã lưu {n} ô cho {name}",
  "Could not save the cells": "Không lưu được các ô",
  "Another campaign sponsors this cell at that time": "Ô này đang thuộc một chiến dịch khác trong khoảng thời gian đó",
  "{n} cell · tap to add / remove": "{n} ô · chạm để thêm / bỏ",
  "{n} cells · tap to add / remove": "{n} ô · chạm để thêm / bỏ",
  "Live": "Đang chạy",
  "Scheduled": "Sắp chạy",
  "Ended": "Đã kết thúc",
  "Codes from a CSV, one per runner who captures a campaign cell, finishes an event or makes its podium.": "Mã từ file CSV, mỗi runner một mã khi chiếm ô của chiến dịch, hoàn thành giải hoặc lọt top 3 giải.",
  "No offers yet.": "Chưa có ưu đãi nào.",
  "{trigger}: {source} · until {date}": "{trigger}: {source} · đến {date}",
  "{claimed} / {total} codes given · {used} used": "Đã phát {claimed} / {total} mã · {used} đã dùng",
  "Codes": "Mã",
  "Could not save the offer": "Không lưu được ưu đãi",
  "Offer": "Ưu đãi",
  "New offer": "Ưu đãi mới",
  "Earned by": "Cách nhận",
  "Campaign (of this brand)": "Chiến dịch (của nhãn hàng này)",
  "Event (not ended)": "Giải (chưa kết thúc)",
  "Choose…": "Chọn…",
  "Title (what the runner gets)": "Tiêu đề (runner nhận được gì)",
  "Description": "Mô tả",
  "Conditions of use": "Điều kiện sử dụng",
  "Valid until": "Dùng đến",
  "Paused (no new codes handed out)": "Tạm dừng (không phát mã mới)",
  "Save, then add codes": "Lưu rồi thêm mã",
  "{n} codes added": "Đã thêm {n} mã",
  "{n} duplicates skipped": "Bỏ qua {n} mã trùng",
  "Could not add the codes": "Không thêm được mã",
  "Codes not given yet were removed": "Đã xoá các mã chưa phát",
  "Codes · {name}": "Mã · {name}",
  "{claimed} of {total} given. Upload a CSV file or paste one code per line (first column; a “code” header is skipped).": "Đã phát {claimed} / {total}. Tải file CSV lên hoặc dán mỗi dòng một mã (lấy cột đầu; bỏ qua dòng tiêu đề “code”).",
  "Choose a CSV file": "Chọn file CSV",
  "Add codes": "Thêm mã",
  "Add 1 code": "Thêm 1 mã",
  "Add {n} codes": "Thêm {n} mã",
  "Remove the {n} codes not given yet": "Xoá {n} mã chưa phát",
  "Expired": "Hết hạn",
  "Out of codes": "Hết mã",
  "No codes yet": "Chưa có mã",
  "Capture a sponsored cell of a campaign": "Chiếm ô tài trợ của một chiến dịch",
  "Finish an event (qualified, with a counted run)": "Hoàn thành giải (đủ điều kiện, có run được tính)",
  "Top 3 of an event": "Top 3 của giải",
  "All brands": "Tất cả nhãn hàng",
  "Cash pledged": "Tiền mặt cam kết",
  "Cash received": "Tiền mặt đã nhận",
  "Goods (value)": "Hiện vật (giá trị)",
  "Report for {name} →": "Báo cáo của {name} →",
  "Nothing recorded yet.": "Chưa ghi khoản nào.",
  "Cash": "Tiền mặt",
  "Goods": "Hiện vật",
  "pledged {date}": "cam kết {date}",
  "event: {name}": "giải: {name}",
  "campaign: {name}": "chiến dịch: {name}",
  "Received {date}": "Đã nhận {date}",
  "Received": "Đã nhận",
  "Saved": "Đã lưu",
  "Could not save": "Không lưu được",
  "Deleted": "Đã xoá",
  "Sponsorship": "Tài trợ",
  "Edit entry": "Sửa khoản tài trợ",
  "New entry": "Khoản tài trợ mới",
  "Goods (what and how many)": "Hiện vật (gì và bao nhiêu)",
  "30 finisher shirts": "30 áo finisher",
  "Amount (VND)": "Số tiền (VND)",
  "Estimated value (VND, optional)": "Giá trị ước tính (VND, không bắt buộc)",
  "For": "Cho",
  "— (the brand in general)": "— (nhãn hàng nói chung)",
  "Campaign: {name}": "Chiến dịch: {name}",
  "Event: {name}": "Giải: {name}",
  "Pledged on": "Ngày cam kết",
  "Note": "Ghi chú",
  "From": "Từ",
  "To": "Đến",
  "Print / PDF": "In / PDF",
  "Runner Wars · sponsor report": "Runner Wars · báo cáo tài trợ",
  "All time": "Toàn thời gian",
  "generated {date}": "lập ngày {date}",
  "Map cell views": "Lượt xem ô trên bản đồ",
  "Cell taps": "Lượt bấm ô",
  "Sponsored cells taken": "Ô tài trợ bị chiếm",
  "Banner views": "Lượt xem banner",
  "Banner taps": "Lượt bấm banner",
  "Runners reached": "Runner tiếp cận",
  "Codes given": "Mã đã phát",
  "Codes used": "Mã đã dùng",
  "Event runners": "Runner tham gia giải",
  "Views and taps per day": "Lượt xem và lượt bấm theo ngày",
  "Campaigns": "Chiến dịch",
  "Cells": "Số ô",
  "Views": "Lượt xem",
  "Taps": "Lượt bấm",
  "Banner": "Banner",
  "Taken": "Bị chiếm",
  "Sponsored events": "Giải được tài trợ",
  "Event": "Giải",
  "Tier": "Hạng",
  "Finishers": "Hoàn thành",
  "Given": "Đã phát",
  "Capture a sponsored cell": "Chiếm ô tài trợ",
  "Finish the event": "Hoàn thành giải",
  "Event podium": "Top 3 giải",
  "Date": "Ngày",
  "What": "Nội dung",
  "Nothing recorded for this period.": "Không có khoản nào trong khoảng thời gian này.",
  "Views and taps are counted per day; no runner or location is stored.": "Lượt xem và lượt bấm được đếm theo ngày; không lưu runner hay vị trí.",
  "views": "lượt xem",
  "taps": "lượt bấm",
  "all time": "toàn thời gian",
  "Totals": "Tổng",
  "Cell views": "Lượt xem ô",
  "Cells taken": "Ô bị chiếm",
  "Source": "Nguồn",
  "Pledged": "Cam kết",
  "Kind": "Loại",
  "Day": "Ngày",
};
